<template>
  <dynamic-tabs
    ref="dynamicTabs"
    tabs-id="user-account-tabs"
    :tabs="tabs"/>
</template>

<script>
import DynamicTabs from '@/views/modules/_components/DynamicTabs.vue';
import UserAccountDetails from '@/views/modules/user/user-account/user-account-details/UserAccountDetails.vue';
import UserAccountSecurity from '@/views/modules/user/user-account/user-account-security/UserAccountSecurity.vue';
import UserAccountBranding from '@/views/modules/user/user-account/user-account-branding/UserAccountBranding.vue';
import UserAccountCompanyPolicies from '@/views/modules/user/user-account/user-account-company-policies/UserAccountCompanyPolicies.vue';
import UserAccountOpeningHours from '@/views/modules/user/user-account/user-account-opening-hours/UserAccountOpeningHours.vue';

/**
 * User account tabs
 *
 * @module views/modules/user-account/UserAccountTabs
 * @author Dilan Useche <dilan8810@gmail.com>
 *
 * @vue-data {Object[]} [tabs=[...]] - tabs to show
 */
export default {
  name: 'UserAccountTabs',
  components: {
    DynamicTabs,
  },
  data() {
    return {
      tabs: [
        {
          icon: 'icon-user',
          iconPack: 'feather',
          label: this.$t('$UserSettings.$Account.$AccountDetails.TabTitle'),
          component: UserAccountDetails,
          path: 'details',
        },
        {
          icon: 'icon-bold',
          iconPack: 'feather',
          label: this.$t('$UserSettings.$Account.$Branding.TabTitle'),
          component: UserAccountBranding,
          path: 'branding',
        },
        {
          icon: 'icon-file',
          iconPack: 'feather',
          label: this.$t('$UserSettings.$Account.$CompanyPolicies.TabTitle'),
          component: UserAccountCompanyPolicies,
          path: 'policies',
        },
        {
          icon: 'icon-clock',
          iconPack: 'feather',
          label: this.$t('$UserSettings.$Account.$OpeningHours.TabTitle'),
          component: UserAccountOpeningHours,
          path: 'opening-hours',
        },
        {
          icon: 'icon-shield',
          iconPack: 'feather',
          label: this.$t('$UserSettings.$Account.$Security.TabTitle'),
          component: UserAccountSecurity,
          path: 'security',
        },
      ],
    };
  },
  created() {
    // Listen for tab switch events from child components
    this.$root.$on('switch-to-account-tab', (tabPath) => {
      this.$refs.dynamicTabs.goTo(tabPath);
    });
  },
  beforeDestroy() {
    // Clean up event listener
    this.$root.$off('switch-to-account-tab');
  },
};
</script>
